export const isOnline = () => navigator.onLine;
